import {
  getEBUserLocale,
  isEBSEmbedded,
} from '@xmatters/common/context/ebsGlobalContext';
import supportedLocales from '../../supportedLocales';

export default function getLocale() {
  const locale =
    (isEBSEmbedded() ? getEBUserLocale() : window.locale) ?? 'en_US';
  // the locale can have more than just the language
  let lang = locale.substring(0, 2);
  // if the language isn't available ...we need to fall back to default(english)
  if (supportedLocales.indexOf(lang) === -1) {
    lang = 'en';
  }
  return lang;
}

export const LanguageKeys = {
  Arabic: 'ar',
  Belarusian: 'be',
  Bulgarian: 'bg',
  Catalan: 'ca',
  Czech: 'cs',
  Danish: 'da',
  German: 'de',
  Greek: 'el',
  English: 'en',
  'English UK': 'en_gb',
  Spanish: 'es',
  Estonian: 'et',
  Finnish: 'fi',
  French: 'fr',
  Hindi: 'hi',
  Croatian: 'hr',
  Hungarian: 'hu',
  Icelandic: 'is',
  Italian: 'it',
  Hebrew: 'iw',
  Japanese: 'ja',
  Korean: 'ko',
  Lithuanian: 'lt',
  Latvian: 'lv',
  Macedonian: 'mk',
  Dutch: 'nl',
  Norwegian: 'no',
  Polish: 'pl',
  Portuguese: 'pt',
  'Brazilian Portuguese': 'pt_br',
  Romanian: 'ro',
  Russian: 'ru',
  Slovak: 'sk',
  Slovenian: 'sl',
  Albanian: 'sq',
  Swedish: 'sv',
  Thai: 'th',
  Turkish: 'tr',
  Ukrainian: 'uk',
  Vietnamese: 'vi',
  Mandarin: 'zh_cn',
  Cantonese: 'zh_hk',
};

export const LocaleKeys = {
  ar: 'Arabic',
  be: 'Belarusian',
  bg: 'Bulgarian',
  ca: 'Catalan',
  cs: 'Czech',
  da: 'Danish',
  de: 'German',
  el: 'Greek',
  en: 'English',
  en_GB: 'English UK',
  es: 'Spanish',
  et: 'Estonian',
  fi: 'Finnish',
  fr: 'French',
  hi: 'Hindi',
  hr: 'Croatian',
  hu: 'Hungarian',
  is: 'Icelandic',
  it: 'Italian',
  iw: 'Hebrew',
  ja: 'Japanese',
  ko: 'Korean',
  lt: 'Lithuanian',
  lv: 'Latvian',
  mk: 'Macedonian',
  nl: 'Dutch',
  no: 'Norwegian',
  pl: 'Polish',
  pt: 'Portuguese',
  pt_BR: 'Brazilian Portuguese',
  ro: 'Romanian',
  ru: 'Russian',
  sk: 'Slovak',
  sl: 'Slovenian',
  sq: 'Albanian',
  sv: 'Swedish',
  th: 'Thai',
  tr: 'Turkish',
  uk: 'Ukrainian',
  vi: 'Vietnamese',
  zh_CN: 'Mandarin',
  zh_HK: 'Cantonese',
};

export const defaultLanguage = 'English';
